import React from 'react';
import './Licitaciones.css';

const circular1 = require("../documents/Circular lic01-22.pdf");
const circular2 = require("../documents/Circular con consulta 01-22.pdf");
const lamadrid = require("../documents/Terraplenes de protección ciudad de Lamadrid- 10 de diciembre 2021_F2.pdf");
const circular2_1 = require("../documents/Circular lic02-22.pdf");
const conventillo = require("../documents/Terraplén y defensas Río Conventillo-Dpto. Chicligasta. 10 de diciembre 2021_F2.pdf");
const circular3 = require("../documents/Circular lic03-22.pdf");
const marapa = require("../documents/Protección de la margen izquierda Río Marapa. 10 de diciembre 2021_F2.pdf");

const licitacionesData = [
  {
    titulo: 'Licitacion Publica Nº 01/22',
    subtitulo: 'Terraplenes de Proteccion Ciudad de Lamadrid',
    expediente: 'Expediente: 4285/325-DEP-2021',
    descripcion: [
      'La Ciudad de Lamadrid se encuentra aproximadamente a 90 km al sur de la ciudad de San Miguel de Tucuman (medido en linea recta). Debido a los sucesos ocurridos durante los veranos de los anos 2015 y 2017 es que se desarrolla el presente proyecto cuyo objetivo principal es disminuir el riesgo de inundacion de la poblacion que alli habita.',
      'Este trabajo surge a partir del informe realizado por la Comision de Emergencia para el Tratamiento de la Problematica de Inundaciones en el Sur de la Provincia de Tucuman, este de Catamarca. Donde se expone la situacion critica de dicha ciudad, dado a las intervenciones en la cuenca de origen antropico que rompen con el equilibrio hidrologico y fluvial de la misma.',
      'Es por ello, que se proyecto un encauce del Marapa, desde aproximadamente 1000m aguas arriba del puente de la RN N°157 hasta casi 2000m aguas abajo del mismo. Ademas, se busco optimizar la capacidad de conduccion del canal de cintura oeste de la ciudad, mediante un encauce desde su naciente hasta su desembocadura en el Marapa.',
      'Por ultimo, cabe aclarar que existe una propuesta realizada por una consultora del BID donde desarrolla una propuesta para intervenir sobre el Rio San Francisco para restaurar el punto de descarga de este ultimo sobre el rio Marapa a aproximadamente 12Km. aguas debajo de la ciudad de Lamadrid, para permitir el paso de las aguas de esta cuenca sobre los banados de Obanta y no afectar directamente a la ciudad de Lamadrid.'
    ],
    apertura: [
      'Lugar: DIRECCION PROVINCIAL DEL AGUA - SIMON BOLIVAR 1095 - SAN MIGUEL DE TUCUMAN.',
      'Fecha y hora: 04/04/2022, 09:00:00'
    ],
    descargas: [
      { label: 'Descargar Circular sin consulta Nº1', file: circular1 },
      { label: 'Descargar Circular con consulta Nº1', file: circular2 },
      { label: 'Descargar Licitacion', file: lamadrid }
    ]
  },
  {
    titulo: 'Licitacion Publica Nº 02/22',
    subtitulo: 'Terraplen y Defensas Rio Conventillo - Dpto. Chicligasta',
    expediente: 'Expediente: 4285/325-DEP-2021',
    descripcion: [
      'La motivacion del presente estudio nace a partir de las consecuencias producidas por las precipitaciones ocurridas el 9 de marzo del presente ano. Donde se produjo un aluvion el Rio Conventillo que destruyo el puente sobre el rio La Jaya y desbordo en varios sectores produciendo afectaciones a la poblacion del Molino, Piedra Grande, La Angostura y en fincas privadas de produccion agricola.',
      'La zona en analisis pertenece a la cuenca del rio Conventillo que se encuentra dentro del Departamento Chicligasta en la provincia de Tucuman. Los sectores afectados se corresponden segun la documentacion tecnica del expediente.'
    ],
    apertura: [
      'Lugar: DIRECCION PROVINCIAL DEL AGUA - SIMON BOLIVAR 1095 - SAN MIGUEL DE TUCUMAN.',
      'Fecha y hora: 05/04/2022, 09:00:00'
    ],
    descargas: [
      { label: 'Descargar Circular sin consulta Nº1', file: circular2_1 },
      { label: 'Descargar Licitacion', file: conventillo }
    ]
  },
  {
    titulo: 'Licitacion Publica Nº 03/22',
    subtitulo: 'Proteccion de Margen Izquierda y Ampliacion de Cauce en Rio Marapa - Dpto. Graneros',
    expediente: 'Expediente: 4270/325-DEP-2021',
    descripcion: [
      'La zona de estudio del Rio Marapa se encuentra ubicada aproximadamente 110 km al sur de la ciudad de San Miguel de Tucuman, siendo Juan B. Alberdi y Graneros las ciudades mas cercanas. Las principales actividades economicas de la zona son la agricola, ganadera y el comercio, aunque la principal actividad es la industria azucarera correspondiente al Ingenio Marapa S.A.',
      'En las crecidas estivales de los anos 2015, 2016 y 2017, el meandro en estudio se fue desplazando hacia el NE, produciendo severos danos a la infraestructura de servicio a la produccion cuya traza es practicamente paralela a la RP N°308.',
      'El proceso erosivo continuo avanzando culminando con el corte de dicho canal de riego en una longitud aproximada de 500 m. Este canal beneficia a 25 productores que cultivan una superficie de 750 Has aproximadamente.'
    ],
    apertura: [
      'Lugar: DIRECCION PROVINCIAL DEL AGUA - SIMON BOLIVAR 1095 - SAN MIGUEL DE TUCUMAN.',
      'Fecha y hora: 05/04/2022, 11:00:00'
    ],
    descargas: [
      { label: 'Descargar Circular sin consulta Nº1', file: circular3 },
      { label: 'Descargar Licitacion', file: marapa }
    ]
  }
];

const Licitaciones = () => (
  <main className="licitaciones-page">
    <section className="licitaciones-hero">
      <div className="licitaciones-shell reveal-on-scroll">
        <h1>Licitaciones</h1>
        <p>
          En esta seccion encontraras las licitaciones de la Direccion Provincial del Agua.
          <p>Consultas: <a href="mailto:licitaciones@dpatuc.com">mesadeentradas@dpatuc.com</a> </p>
        </p>
      </div>
    </section>

    <section className="licitaciones-listado">
      <div className="licitaciones-shell licitaciones-grid">
        {licitacionesData.map((item) => (
          <article key={item.titulo} className="card-licitacion reveal-on-scroll">
            <span className="licitacion-badge">Licitacion</span>
            <h2>{item.titulo}</h2>
            <h3>{item.subtitulo}</h3>
            <p className="expediente">{item.expediente}</p>

            <div className="descripcion-licitacion">
              {item.descripcion.map((parrafo) => (
                <p key={parrafo}>{parrafo}</p>
              ))}
            </div>

            <div className="info-apertura">
              <strong>Apertura de sobres</strong>
              {item.apertura.map((linea) => (
                <span key={linea}>{linea}</span>
              ))}
            </div>

            <div className="botones-descarga">
              {item.descargas.map((descarga) => (
                <a key={descarga.label} href={descarga.file} className="btn-descarga" download>
                  {descarga.label}
                </a>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default Licitaciones;

